'use client'

import { css, cx } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'

import ClockIcon from '@src/quince-components/src/atoms/cart-urgency/icons/clock_v2.inline.svg'
import { Icon } from '@src/quince-components/src/atoms/icon'

const cartUrgencyMessageCss = css({
  textStyle: 'body-14',
  display: 'flex',
  alignItems: 'center',
  gap: 'space-4',
  width: 'full',
  p: 'space-8',
  bg: 'paperwhite',
})

const clockIconCss = css({
  width: 'var(--web-ui-spacing-space-16)',
  height: 'var(--web-ui-spacing-space-16)',
  flexShrink: 0,
})

interface CartUrgencyProps {
  className?: string
}

export const CartUrgencyDS = ({ className }: CartUrgencyProps) => {
  const { t } = useTranslation('common')

  return (
    <div className={cx(cartUrgencyMessageCss, className)}>
      <Icon iconSvg={ClockIcon} className={clockIconCss} /> {t('selling_fast_miss_out')}
    </div>
  )
}
